import React from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices,SelectInput,
    Create, SimpleForm, TextInput, DateInput,ReferenceInput,
    BooleanInput, NumberInput, ImageInput, ImageField,AutocompleteInput
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';

export const DistrictCreate = props => (
    <Create {...props}  title="District">
        <SimpleForm redirect="list"  
        variant="outlined">
            <TextInput validate={required()} source="code" label="District Code" fullWidth={true} />
            <TextInput validate={required()} source="name" label="District Name" fullWidth={true} />
            
            <ReferenceInput variant="outlined" label="State" source="stateId"
                            reference="states" perPage={500}
                           
                            validate={required()} 
                            sort={{ field: 'name', order: 'ASC' }}
                            shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}
                            fullWidth={true} >
                            {/* <SelectInput validate={required()} optionText="name" /> */}
                            <AutocompleteInput validate={required()} optionText="name" variant="outlined"
                             shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}  fullWidth={true} 
                             
                             />
                        </ReferenceInput>
            <BooleanInput initialValue={true} source="isActive" />
        </SimpleForm>
    </Create>
);